import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES, LOCALE_KEY } from "@/i18n";
import { localePath, parseLocaleFromPath } from "@/lib/locale";

export default function LangSwitcher({ compact = false }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const { locale: currentLocale, pathWithoutLocale } = parseLocaleFromPath(location.pathname);

  const onSwitch = (loc) => {
    if (loc === currentLocale) return;
    i18n.changeLanguage(loc);
    localStorage.setItem(LOCALE_KEY, loc);
    navigate(localePath(loc, pathWithoutLocale) + location.search, { replace: false });
  };

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-lg border border-border/60 bg-card/60 backdrop-blur p-1 ${compact ? "text-[11px]" : "text-xs"}`}
      data-testid="lang-switcher"
      aria-label={t("lang.switch_label")}
    >
      {SUPPORTED_LOCALES.map((loc) => (
        <button
          key={loc}
          type="button"
          onClick={() => onSwitch(loc)}
          data-testid={`lang-switch-${loc}`}
          aria-current={loc === currentLocale ? "true" : undefined}
          className={`px-2 py-1 rounded-md font-medium tracking-wider uppercase transition-colors ${
            loc === currentLocale
              ? "bg-primary text-primary-foreground shadow-interactive"
              : "text-foreground/70 hover:text-primary"
          }`}
        >
          {t(`lang.${loc}_short`)}
        </button>
      ))}
    </div>
  );
}
